module.exports = __webpack_public_path__ + "img/shiti.b706fcac.png";